
import React from 'react';
import { AnalysisWithProcurement } from '@/types/analysis';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock } from 'lucide-react';

type ProgressCardProps = {
  analysis: AnalysisWithProcurement;
  onUpdate: (analysisId: string, progress: number | null) => Promise<void>;
};

const ProgressCard = ({ analysis, onUpdate }: ProgressCardProps) => {
  return (
    <Card key={analysis.id}>
      <CardHeader className="pb-3">
        <div className="flex justify-between items-start">
          <div>
            <CardTitle className="text-lg">{analysis.procurement.title}</CardTitle>
            <CardDescription className="mt-1">
              {analysis.procurement.authority} • Tillagd {new Date(analysis.created_at).toLocaleDateString('sv-SE')}
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-3">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 text-yellow-600">
            <Clock size={18} />
            <span>Pågående analys</span>
          </div>
          <div className="flex-1">
            <div className="w-full bg-gray-200 rounded-full h-2.5">
              <div 
                className="bg-yellow-500 h-2.5 rounded-full" 
                style={{ width: `${analysis.progress || 0}%` }}
              ></div>
            </div>
          </div>
          <div className="text-sm text-gray-600">{analysis.progress || 0}%</div>
          
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => onUpdate(analysis.id, analysis.progress)}
          >
            Uppdatera status
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProgressCard;
